<template>
  <div>
    <transition
      name="snackbar"
      mode="out-in"
    >
      <div
        v-if="snackbar.showSnackbar"
        class="snackbar"
      >
        {{ snackbar.message }}
        <button
          v-if="snackbar.timeout === 0"
          class="snackbar-button"
          @click="closeTheSnackbar"
        >
          {{ snackbar.buttonText }}
        </button>
      </div>
    </transition>
    <div class="footer">
      <div
        v-if="debug"
        class="debug"
      >
        {{ debugInfo }}
        <button @click="showToast">
          show refresh
        </button>
        <button @click="showSnack">
          show snack
        </button>
      </div>
      <div class="version">
        {{ versionInfo }}
      </div>
      <div class="copyright">
        &copy; 2021, 2022, 2023, 2024
        <a href="https://blog.paulcanbuildthat.com">paulcanbuildthat.com</a>
      </div>
    </div>
  </div>
</template>

<script>
import UpdateSW from "../../mixins/updatesw.js";
import ShowSnackbar from "../../mixins/ShowSnackbar.js";

export default {
  mixins: [UpdateSW, ShowSnackbar],
  data() {
    return {
      appUpdateSnackbar: false,
    }
  },
  computed: {
    versionInfo() {
      return (
        this.appName + " " + this.appVersion + " (" + this.productionState + ")"
      );
    },
    appVersion() {
      return this.$store.getters.appVersion;
    },
    appName() {
      return this.$store.getters.appName;
    },
    productionState() {
      return this.$store.getters.productionState;
    },
    debug() {
      return this.$store.getters.debugMode;
    },
    debugInfo() {
      return "UID: " + this.$store.getters.userId +
      " / SID: " + this.$store.getters["seasons/currentSeason"].seasonId
    },
    footerHeight() {
      if ( this.debug ) {
        return "6rem";
      } else {
        return "4rem";
      }
    },
    footerColor() {
      return this.$store.getters.backgroundColor;
    },
    buttonColor() {
      return this.$store.getters.foregroundColor;
    },
    snackbar() {
      return this.$store.getters.snackbar;
    },
    showSnackbar() {
      return this.$store.getters.snackbar.showSnackbar;
    },
    snackbarColor() {
      return this.$store.getters.snackbar.color;
    },
  },
  watch: {
    showSnackbar: function (val) {
      if ( val && this.snackbar.timeout > 0 ) {
        // just set to true and we have a timeout
        setTimeout(() => {
          this.snackbar.showSnackbar = false;
          this.$store.commit("setSnackbar", this.snackbar);
        }, this.snackbar.timeout);
      }
    },
    updateExists: function (val) {
      console.group("updateExists")

      if ( val ) {
        this.appUpdateSnackbar = true;
        console.info("appUpdateSnackbar = ", this.appUpdateSnackbar)
        this.openToastSnackbar("A newer version is available: click Update to refresh", "warn", "Update");
      }

      console.groupEnd();
    }
  },
  methods: {
    closeTheSnackbar() {
      console.group("closeTheSnackbar");

      console.info("appUpdateSnackbar = ", this.appUpdateSnackbar);
      if ( this.appUpdateSnackbar ) {
        console.info("calling refreshApp");
        this.refreshApp();
        this.appUpdateSnackbar = false;
      }

      this.closeSnackbar(this.$store)
      console.groupEnd();
    },
    showToast() {
      // this.openToastSnackbar("I'm the snackbar toast message", "warn", "Close Me!");
      document.dispatchEvent(new CustomEvent('swUpdated', { detail: "hello" }));
    },
    showSnack() {
      this.openSnackbar("I'm the snackbar message", "success");
    },
  }
};
</script>
<style scoped>
.footer {
  display: inline-block;
  background-color: v-bind(footerColor);
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: v-bind(footerHeight);
  padding: 0.5rem 0;
  align-items: middle;
  text-align: left;
  font-size: 0.8rem;
}

.debug {
  display: inline-block;
  width: 100%;
  color: orange;
  margin-bottom: 0.5rem;
  text-align: center;
  font-size: 1rem;
}

.version {
  margin-bottom: 0.5rem;
  display: inline-block;
  text-align: center;
  width: 100%;
  color: rgb(207, 204, 204);
  font-style: italic;
}

.copyright {
  margin-bottom: 0.5rem;
  display: inline-block;
  text-align: center;
  width: 100%;
  color: white;
}

.copyright a {
  text-decoration: none;
  color: v-bind(buttonColor);
  font-weight: bold;
}

.snackbar {
  background: v-bind(snackbarColor);
  color: white;
  padding: .5rem 2rem;
  border-radius: 1rem;
  display: inline-block;
  position: fixed;
  bottom: calc(v-bind(footerHeight) + 0.5rem);
  left: 20px;
}

.snackbar-button {
  background: v-bind(footerColor);
  color: white;
  border-radius: 4px;
  margin-left: 1rem;
}

.snackbar-enter-from,
.snackbar-leave-to {
  opacity: 0;
  transform: scale(0.8);
}

.snackbar-enter-active {
  transition: all 0.3s ease-out;
}

.snackbar-leave-active {
  transition: all 0.3s ease-in;
}

.snackbar-enter-to,
.snackbar-leave-from {
  opacity: 1;
  transform: scale(1);
}
</style>
